module.exports = __webpack_public_path__ + "static/007500-6be489a0c39a40a74c624ad375a41853.jpg";